import React, { PureComponent, Fragment } from 'react';
import Humanize from 'humanize-plus';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled, { css } from 'styled-components';
import { Text, Separator, Button, Card, Row, Col } from '@cuemath/comps';
import { LinkButton } from 'modules/list';
import { post as createPaymentLink } from 'actions/student-payment-link';
import { get as getOnlinePlans } from 'actions/pricing';
import { get as getRenewalPlans } from 'actions/renewal-plans';
import { getAll as getAllOnlineBands } from 'actions/online-bands';
import { get as getDiscountDetails } from 'actions/discounts';
import { patch as patchApplyCoupon } from 'actions/pricing';
import { get as getPlanCourses } from 'actions/online-plan-courses';
import { getAll as getAllAddons } from 'actions/addons';
import { openModal, closeModal } from 'actions/modal';
import { getAll as getTeacherList } from 'actions/teacher-list';
import { TEACHERS_PER_PAGE } from 'constants/list';
import { CURRENCY_SYMBOL_MAP } from 'modals/utils/currency-helper';
import { Close } from 'styled-icons/material/Close';
import {
  Message,
  ButtonWrapper,
  renderFormField as renderFormFieldModule,
  getOptions,
  HeaderHead,
  Field,
  Label,
  Asterisk,
  SelectInput,
  Input,
  FieldWrapper as MainFieldWrapper,
} from 'modules/form';
import MODAL from 'constants/modal';
import {
  FIELD_TYPES,
  newPaymentFields,
  getOnChangeMethod,
  getInputChangeMethod,
  MODAL_FORM,
  addonDataFields,
  teacherStates,
  ERROR_MSG_FOR_TEACHER_LIST,
  MENU_CLOSE,
  updateFieldChoices,
  ENROLLMENT_TYPE,
  HYBRID_ENROLLMENT_TYPES,
  emiOptionsLabel,
} from 'constants/form';
import CourseInfo from './course-info-view';
import COLORS from 'constants/colors';
import CopyButton from '../../comps/copy-button';

const CopyButtonWrapper = styled.div`
  width: 300px;
`;

const CopyButtonText = styled.div`
  width: 40%;
`;

const ClearBtnWrapper = styled.div`
  border: 1px solid ${COLORS.DISABLE_COLOR};
  background-color: ${COLORS.WHITE};
  background: ${COLORS.WHITE};
  cursor: pointer;
  color: ${COLORS.BLACK};
  display: flex;
  align-items: center;
`;

const CouponBtnWrapper = styled(Button)`
  margin-left: 8px;
`;

const CloseIcon = styled(Close)`
  color: ${COLORS.GRAY};
`;

const MainFieldWrapperr = styled(MainFieldWrapper)`
  position: relative;
`;

const PaymentFieldWrapper = styled.div`
  width: 80%;
`;

const PaymentText = styled(Text)`
  font-size: 18px;
  margin: 20px 0px;
`;

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px;
`;

const SeparatorWrapper = styled(Separator)`
  width: 100%;
  margin-left: 5px;
  margin: 10px 0px;
`;

const SpanWrapper = styled.span`
  margin: 0px 20px;
`;

const RowWrapper = styled(Row)`
  display: flex;
  justify-content: center;
  margin: 5px 0px;
`;

const CardWrapper = styled(Card)`
  margin-bottom: 12px;
  padding: 10px;
  overflow: visible;
`;

const FieldWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0px;
`;

const DivWrapper = styled.div`
  display: flex;
  justify-content: center;
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop};
      justify-content: flex-end;
      width: 173px;
      margin-left: 394px;
    `};
`;

const CustomLink = styled.a`
  color: ${COLORS.BOSTON_BLUE};
  :visited {
    color: ${COLORS.PURPLE};
  }
  :hover {
    color: blue;
  }
`;
const EmiWrapper = styled.div`
  display: flex;
  padding-left: 4px;
  gap: 114px;
  & > input {
    width: 18px;
  }
`;

const INR = 'INR';

const discountParams = (onlinePlanId, isIndianPayment, teacherId, couponCode) => {
  const query = {
    is_indian_payment: isIndianPayment,
    online_plan_id: onlinePlanId,
  };
  if (teacherId) {
    query.teacher_id = teacherId;
  }
  if (couponCode) {
    query.coupon_code = couponCode.trim();
  }
  return query;
};

const isIndianPayment = currency => currency === INR;

class NewPaymentModal extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      createPaymentLink: PropTypes.func.isRequired,
      getOnlinePlans: PropTypes.func.isRequired,
      getAllOnlineBands: PropTypes.func.isRequired,
      getPlanCourses: PropTypes.func.isRequired,
      getAllAddons: PropTypes.func.isRequired,
      getTeacherList: PropTypes.func.isRequired,
      patchApplyCoupon: PropTypes.func.isRequired,
    }).isRequired,
    student: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      errorText: null,
      message: null,
      form: this.getFormDefaults(),
      formFields: this.getFormFields(),
      paymentLinkPost: store.post(),
      bandId: null,
      onlineBandOptions: [],
      course_name: null,
      access_type: null,
      updatePlan: true,
      onlinePlanCourses: [],
      courseListData: null,
      couponCodeApplied: false,
      onlinePlan: null,
      linkGenerated: false,
      filteredPlanCourses: [],
      allPricingPlans: [],
      FinalPlanSelected: [],
      addonForm: [],
      allAddonOptions: [],
      onlinePlanOptions: [],
      teachersData: null,
      teacherSearchKey: null,
      couponApplied: false,
      discountApiCalled: false,
      shouldHideOptions: false,
      renewalPlanData: null,
      hiddenFormField: [],
      showDefalutPaymentLink: false,
      isEMIEnabled: false,
    };

    newPaymentFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  getFormDefaults = () => {
    const formDefaults = {};
    const { student } = this.props;
    newPaymentFields.forEach(field => {
      formDefaults[field.name] =
        !!student && student[field.param] ? student[field.param] : field.default;
    });
    return formDefaults;
  };

  getFormFields = () => {
    return newPaymentFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({
          field: field.name,
          onlineBandOptions: [],
          onlinePlanOptions: [],
          filteredPlanCourses: [],
        });

      return field;
    });
  };

  getAddonFields = () => {
    return addonDataFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({
          field: field.name,
          addonTypeOptions: [],
          addonNameOptions: [],
          addonCourseOptions: [],
        });
      return field;
    });
  };

  handleEmiToggle = () => {
    this.setState(prevState => ({
      isEMIEnabled: !prevState.isEMIEnabled,
    }));
  };

  static getDerivedStateFromProps(props, state) {
    let getUpdatedAddonForm = (addonForm, field_name, choicesList) => {
      return addonForm.map(addon => {
        addon.addonFormFields.find(
          field => field.name === field_name,
        ).choices = choicesList;
        return addon;
      });
    };

    const newState = {};
    const {
      addonsList,
      onlineBand,
      onlinePlanList,
      studentPaymentLink,
      teacherList,
      discountDetails,
      student: { id: studentId } = {},
      renewalPlans,
      isAdmissionsCase,
    } = props;
    const {
      paymentLinkPost,
      bandId,
      onlinePlan,
      form,
      formFields,
      addonForm,
      linkGenerated,
      teacherSearchKey,
      page,
      discountApiCalled,
      renewalPlanData,
      shouldHideOptions,
    } = state;

    const { currency, teacher_id: teacherId, coupon_code: couponCode, onlinePlanId } =
      form || {};

    const listParams = { page, per_page: TEACHERS_PER_PAGE, search: teacherSearchKey };

    const newPaymentLinkPost = store.post(studentPaymentLink, paymentLinkPost.id);
    const onlineBandData = store.getAll(onlineBand);

    // student_id lets the gateway hard-restrict one-time plans to offline
    // courses for admissions (must match the fetch query key below).
    const queryObj = { grade: form.grade_band, is_active: true, student_id: studentId };
    const onlinePlanData = store.get(onlinePlanList, bandId, queryObj);
    let newForm = { ...form };

    let query;
    if (discountApiCalled && studentId && currency && onlinePlanId) {
      query = discountParams(
        onlinePlanId,
        isIndianPayment(currency),
        teacherId,
        couponCode,
        false,
      );
      const discountData = store.get(discountDetails, studentId, query);

      const { isLoaded, data, __ERROR__: error } = discountData || {};
      const { eligible_discounts: eligibleDiscounts, discount_summary: discountSummary } =
        data || {};
      const { invalid_discounts: invalidDiscounts } = discountSummary || {};
      const { COUPON_CODE: eligibleCouponCode } = eligibleDiscounts || {};
      newForm.couponSuccessfullyApplied = false;
      if (isLoaded) {
        newForm.discountsAndCreditsData = data;
        if (eligibleCouponCode) {
          newForm.couponSuccessfullyApplied = true;
        }
        const [discount] = invalidDiscounts || [];
        const { reason } = discount || {};
        if (reason) {
          newState.errorText = reason;
        }
        newState.discountApiCalled = false;
      } else if (error) {
        newState.errorText = 'Something went wrong';
        newState.discountApiCalled = false;
      }
    }

    const addonsData = store.getAll(addonsList);

    newState.formFields = formFields;
    let newAddonForm = [...addonForm];

    const renewalPlanGet = store.get(renewalPlans, studentId);
    const { data, isLoaded: isRenewalPlansLoaded } = renewalPlanGet || {};

    if (!renewalPlanData && isRenewalPlansLoaded) {
      newState.renewalPlanData = data;
    }

    if (onlineBandData.isLoaded) {
      // Admissions can only enroll into offline courses (online admissions pay
      // on the leap platform), and offline plans exist only for India — so
      // restrict the band list to India for admissions. Everyone else sees all.
      const bandList = isAdmissionsCase
        ? (onlineBandData.data || []).filter(
            band => band.country === 'IN' || band.code === 'IN' || band.name === 'India',
          )
        : onlineBandData.data;
      newState.onlineBandOptions = bandList;
      const choicesList = getOptions({
        field: 'online_band',
        onlineBandOptions: bandList,
      });
      newState.formFields.find(
        field => field.name === 'online_band',
      ).choices = choicesList;
    }

    if (onlinePlanData && onlinePlanData.isLoaded) {
      newState.filteredPlanCourses = [];
      newState.onlinePlanOptions = onlinePlanData.data;
      onlinePlanData.data.forEach(
        planData =>
          planData &&
          planData.plan_courses.forEach(plan_course =>
            newState.filteredPlanCourses.push(plan_course),
          ),
      );

      const arrayOfCourses = [];
      newState.filteredPlanCourses.map(
        planCourse => planCourse.course && arrayOfCourses.push(planCourse.course.type),
      );

      const choicesListForCourseType = getOptions({
        field: 'course_type',
        onlinePlanOptions: arrayOfCourses,
      });
      newState.formFields.find(
        field => field.name === 'course_type',
      ).choices = choicesListForCourseType;

      if (form.dynamic_no_of_classes) {
        const addonCourseChoicesList = getOptions({
          field: 'addon_course',
          addonCourseOptions: onlinePlan.plan_courses,
        });
        newState.addonCourseChoices = addonCourseChoicesList;
        newAddonForm = getUpdatedAddonForm(
          newAddonForm,
          'addon_course',
          addonCourseChoicesList,
        );
      }
    }

    if (linkGenerated && newPaymentLinkPost.resolved) {
      if (newPaymentLinkPost.resolved.isCreated) {
        const { data: { link: paymentLink } = {} } = newPaymentLinkPost.resolved;
        newState.SlotPost = newPaymentLinkPost;
        newState.hyperLink = paymentLink;
        newState.message = 'Payment Link created successfully';
        newState.errorText = null;
      } else if (newPaymentLinkPost.resolved.isCreatingFailed) {
        newState.errorText = store.getError(newPaymentLinkPost.resolved)
          ? store.getError(newPaymentLinkPost.resolved).message
          : 'Something went wrong';
        newState.message = null;
        newState.hyperLink = null;
      }
      newState.linkGenerated = false;
    }

    if (addonsData && addonsData.isLoaded) {
      newState.allAddonOptions = addonsData.data;
      newState.addonsTypeOptions = Object.keys(newState.allAddonOptions);
      const addonTypeChoicesList = getOptions({
        field: 'addon_type',
        addonTypeOptions: newState.addonsTypeOptions,
      });
      newAddonForm = getUpdatedAddonForm(
        newAddonForm,
        'addon_type',
        addonTypeChoicesList,
      );
    }
    newState.teachersData = store.getAll(teacherList, listParams);

    newState.form = newForm;
    newState.addonForm = newAddonForm;
    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getAllOnlineBands();
    actions.getAllAddons();
  }

  errorMsg = (studenId, onlinePlanId) => {
    if (!studenId) {
      return 'Student Id is mandatory';
    }
    if (!onlinePlanId) {
      return 'Please select a plan';
    }
    return null;
  };

  callDiscountApi = (couponCode, onlinePlanId, indianPayment, newTeacherId) => {
    const { actions, student } = this.props;
    const { id: studenId } = student || {};
    const { form, couponApplied } = this.state;
    const { teacher_id: teacherId } = form || {};
    const newform = { ...form };
    newform.teacher_id = newTeacherId || teacherId;
    newform.coupon_code = !couponApplied ? ' ' : couponCode;

    const errorMessage = this.errorMsg(studenId, onlinePlanId);
    if (errorMessage) {
      this.setState({ errorText: errorMessage });
      return;
    } else if (!couponApplied) {
      this.setState({ errorText: null });
    }

    const query = discountParams(
      onlinePlanId,
      indianPayment,
      newform.teacher_id,
      newform.coupon_code,
    );
    this.setState({ form: newform, discountApiCalled: true }, () =>
      actions.getDiscountDetails(studenId, query),
    );
  };

  onTeacherSearch = (val, reason) => {
    const { action } = reason;
    const { actions } = this.props;
    const { errorText } = this.state;
    const { EXCLUDE_INACT_INTR } = teacherStates;

    const listParams = { page: 1, per_page: TEACHERS_PER_PAGE, search: val };

    const filterData = {
      page: 1,
      per_page: TEACHERS_PER_PAGE,
      state: EXCLUDE_INACT_INTR,
      search: val,
      with_teacher_band: true,
    };

    if (val && val.length <= 4 && action !== MENU_CLOSE) {
      this.setState({ errorText: ERROR_MSG_FOR_TEACHER_LIST });
      return;
    }
    if (errorText) {
      this.setState({ errorText: null });
    }

    if (action !== MENU_CLOSE || val.length !== 0) {
      this.setState({ teacherSearchKey: val }, () => {
        actions.getTeacherList(listParams, filterData);
      });
    }
  };

  onChange = (key, value) => {
    const { form } = this.state;

    const newForm = { ...form };
    newForm[key] = value;

    const stateChanges = { errorText: null, form: newForm };
    this.setState(() => ({ ...stateChanges }));
  };

  getFieldOptions = (fieldName, fieldOptions, array) => {
    return getOptions({
      field: fieldName,
      [fieldOptions]: array,
    });
  };

  renderTeachersList = () => {
    const { teachersData, formFields } = this.state;
    const { data } = teachersData || {};

    const teachersDataAvailable = data && Array.isArray(data) && data.length > 0;

    if (teachersDataAvailable) {
      const choices = this.getFieldOptions(
        'teachers_list',
        'teachersDataOptions',
        teachersData.data,
      );

      updateFieldChoices(['teacher_id'], formFields, choices);
    }
  };

  fetchUniqueValues = arrayField => {
    return arrayField.filter((value, index, array) => array.indexOf(value) === index);
  };

  fetchArrayOFAllTypes = (finalFilteredPlanCourses, type) =>
    finalFilteredPlanCourses.map(planCourse => planCourse[type]);

  checkTeacherStudentBandMismatch = (onlineBandId, teacherId, enrollmentType) => {
    const { teachersData } = this.state;
    const { data: teachers } = teachersData || {};
    const isHybridPlan = HYBRID_ENROLLMENT_TYPES.includes(enrollmentType);
    const selectedTeacher = teachers.find(teacher => teacher.id === teacherId);
    const { online_band_details: { online_band_id: teacherBandId } = {} } =
      selectedTeacher || {};

    const isTeacherStudentBandMismatch =
      isHybridPlan && onlineBandId && teacherBandId !== onlineBandId;

    return isTeacherStudentBandMismatch;
  };

  getRenewalPlanIds = () => {
    const { renewalPlanData } = this.state;
    const { renewal_plans: plans } = renewalPlanData || {};
    if (plans && plans.length) {
      return plans.map(item => item.id);
    }
    return null;
  };

  shouldShowRenewalPaymentLink = (finalPlanSelected, onlineBandOptions) => {
    const { studentDetail } = this.props;
    const { renewalPlanData } = this.state;
    const { renewal_plans: plans, student_info: student } = renewalPlanData || {};
    const {
      plan_courses: selectedPlanCourses,
      online_band_id: onlineBandId,
      currency: spCurrency,
    } = finalPlanSelected[0] || {};

    const {
      enrollment_type: spEnrollmentType,
      no_of_classes: spNoOfClasses,
      duration: spDuration,
      class_ratio: spClassRatio,
      course,
      grade: spGrade,
    } = selectedPlanCourses[0] || {};
    const onlineBand = onlineBandOptions.find(item => item.id === onlineBandId);

    const { id: spOnlineBandId, related_online_band_id: sprelatedOnlineBandId1 } =
      onlineBand || {};

    const relatedOnlineBand = onlineBandOptions.find(
      item => item.related_online_band_id === onlineBandId,
    );

    const { id: sprelatedOnlineBandId2 } = relatedOnlineBand || {};

    const { stream: spStream } = course || {};
    const { grade } = student || {};

    const kgTo7Grade = ['KG', '1', '2', '3', '4', '5', '6', '7'];
    const isKgTo7SPgrade = kgTo7Grade.includes(spGrade);
    const isKgTo7Grade = kgTo7Grade.includes(grade);

    const nineToTwelveGrade = ['9', '10', '11', '12'];
    const isNineToTwelveSPGrade = nineToTwelveGrade.includes(spGrade);
    const isNineToTwelveGrade = nineToTwelveGrade.includes(grade);

    const { primary_course: primaryCourse } = studentDetail || {};
    const { validity_till_date: validityTillDate } = primaryCourse || {};
    const secondsInADay = 86400;
    const daysToAdd = 90;
    const secondsT0Add = daysToAdd * secondsInADay;

    let shouldShow = false;
    plans.forEach(item => {
      const {
        enrollment_type: enrollmentType,
        no_of_classes: noOfClasses,
        duration,
        class_ratio: classRatio,
        currency,
        online_band_id: onlineBandId,
      } = item || {};

      const showRPLink =
        spStream === 'MATH' &&
        currency === spCurrency &&
        currency === 'INR' &&
        (sprelatedOnlineBandId1 === onlineBandId ||
          sprelatedOnlineBandId2 === onlineBandId ||
          spOnlineBandId === onlineBandId) &&
        ((isKgTo7Grade && isKgTo7SPgrade) ||
          (grade === spGrade && spGrade === '8') ||
          (isNineToTwelveSPGrade && isNineToTwelveGrade)) &&
        spEnrollmentType === enrollmentType &&
        noOfClasses === spNoOfClasses &&
        duration === spDuration &&
        classRatio === spClassRatio;

      if (validityTillDate > 0) {
        if (showRPLink && (validityTillDate + secondsT0Add) * 1000 > Date.now()) {
          shouldShow = true;

          return;
        }
      } else {
        if (showRPLink) {
          shouldShow = true;

          return;
        }
      }
    });

    return shouldShow;
  };

  onOptionChange = (key, value) => {
    const { student, studentDetail } = this.props;

    const { primary_course: primaryCourse } = studentDetail || {};
    const { validity_till_date: validityTillDate } = primaryCourse || {};
    const {
      form,
      formFields,
      onlinePlanOptions,
      filteredPlanCourses,
      renewalPlanData,
      hiddenFormField,
      onlineBandOptions,
    } = this.state;
    const { can_create_renewal_payment: showNormalFlow, renewal_plans: plans } =
      renewalPlanData || {};

    const { id: studenId } = student || {};
    const { addonForm } = this.state;
    let newAddonForm = [...addonForm];
    const { actions } = this.props;
    let newForm = { ...form };
    newForm[key] = value;
    let stateChanges = {};
    let errorMessage = '';
    const newState = {};
    newState.formFields = formFields;
    let fieldsToBeClear = [];
    let fieldChoicesToBeClear = [];
    let uniqueEnrollmentTypes = [];
    const ClearAddonCourse = () => {
      newAddonForm.map(addon => {
        addon.addonFormFields.find(field => field.name === 'addon_course').choices = [];
        addon.addon_course = null;
        return addon;
      });
    };
    const hideFormFields = fields => {
      const hiddenFormField = [];

      const newFields = formFields.filter(field => {
        if (fields.includes(field.name)) {
          hiddenFormField.push(formFields.find(item => item.name === field.name));
          return false;
        }
        return field;
      });

      stateChanges.hiddenFormField = hiddenFormField;
      stateChanges.formFields = newFields;
    };

    const UpdateFieldsValues = (fields, value) => {
      fields.map(field => (newForm[field] = value));
    };
    const fetchDurationOptions = (data, val, courseType) => {
      stateChanges.couponApplied = false;
      stateChanges.onlinePlan = null;
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;
      fieldsToBeClear = [
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'currency',
        'amount',
        'onlinePlanId',
        'dynamic_duration',
        'teacher_id',
      ];

      UpdateFieldsValues(fieldsToBeClear, null);

      fieldChoicesToBeClear = ['dynamic_no_of_classes', 'dynamic_class_ratio'];
      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];
      updateFieldChoices(fieldChoicesToBeClear, formFields, []);

      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();
      const finalFilteredPlanCourses = data.filter(
        ({ enrollment_type: enrollmentType, course }) =>
          enrollmentType === val && course && course.type === courseType,
      );
      const arrayOfDuration = this.fetchArrayOFAllTypes(
        finalFilteredPlanCourses,
        'duration',
      );
      const uniqueEnrollmentTypes = this.fetchUniqueValues(arrayOfDuration);
      const choicesListForDuration = this.getFieldOptions(
        'dynamic_duration',
        'onlinePlanOptions',
        uniqueEnrollmentTypes,
      );
      updateFieldChoices(
        ['dynamic_duration'],
        stateChanges.formFields,
        choicesListForDuration,
      );
    };

    if (key === 'online_band' && value !== form[key] && value) {
      stateChanges.bandId = value;
      stateChanges.couponApplied = false;
      fieldsToBeClear = [
        'grade_band',
        'course_type',
        'dynamic_duration',
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'onlinePlanId',
        'enrollment_type',
        'teacher_id',
      ];
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;
      UpdateFieldsValues(fieldsToBeClear, null);
      stateChanges.onlinePlan = null;
      stateChanges.filterplanCourses = [];
      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];
      fieldChoicesToBeClear = [
        'course_type',
        'dynamic_duration',
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'enrollment_type',
      ];

      updateFieldChoices(fieldChoicesToBeClear, stateChanges.formFields, []);
      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();
    }

    if (key === 'grade_band' && value !== form[key] && value) {
      stateChanges.couponApplied = false;
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;

      fieldsToBeClear = [
        'course_type',
        'dynamic_duration',
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'onlinePlanId',
        'enrollment_type',
        'teacher_id',
      ];
      UpdateFieldsValues(fieldsToBeClear, null);

      if (!this.getRenewalPlanIds()) {
        actions.getRenewalPlans(studenId);
      }

      stateChanges.onlinePlan = null;
      stateChanges.filteredPlanCourses = [];
      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];
      fieldChoicesToBeClear = [
        'course_type',
        'dynamic_duration',
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'enrollment_type',
      ];
      updateFieldChoices(fieldChoicesToBeClear, stateChanges.formFields, []);
      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();
      const query = {
        grade: value,
        is_active: true,
        student_id: this.props.student && this.props.student.id,
      };

      actions.getOnlinePlans(this.state.bandId, query);
    }
    if (key === 'course_type') {
      stateChanges.couponApplied = false;
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;

      fieldsToBeClear = [
        'dynamic_duration',
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'onlinePlanId',
        'enrollment_type',
        'teacher_id',
      ];
      UpdateFieldsValues(fieldsToBeClear, null);
      stateChanges.onlinePlan = null;

      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];
      fieldChoicesToBeClear = ['dynamic_no_of_classes', 'dynamic_class_ratio'];
      updateFieldChoices(fieldChoicesToBeClear, stateChanges.formFields, []);
      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();

      const filteredCategory = filteredPlanCourses.filter(
        mappedPlanCourse =>
          mappedPlanCourse.course && mappedPlanCourse.course.type === value,
      );

      const arrayOfEnrollmentTypes = filteredCategory.map(
        ({ enrollment_type: enrollmentType }) => enrollmentType,
      );

      uniqueEnrollmentTypes = this.fetchUniqueValues(arrayOfEnrollmentTypes);
      const { REGULAR } = ENROLLMENT_TYPE;
      if (
        uniqueEnrollmentTypes.filter(
          enrollmentTypeOption => enrollmentTypeOption === REGULAR,
        ).length
      ) {
        // updating default value as REGULAR if dropdown contains REGULAR
        newForm['enrollment_type'] = REGULAR;
        // If user goes with default REGULAR type (without changing enrollment_type), then fetch duration options accordingly
        fetchDurationOptions(filteredCategory, REGULAR, value);
      }
      const choicesListForDuration = this.getFieldOptions(
        'enrollmentType',
        'enrollmentTypeOptions',
        uniqueEnrollmentTypes,
      );
      updateFieldChoices(['enrollment_type'], formFields, choicesListForDuration);
    }
    if (key === 'enrollment_type') {
      fetchDurationOptions(filteredPlanCourses, value, form.course_type);
    }
    if (key === 'dynamic_duration') {
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;

      stateChanges.couponApplied = false;
      stateChanges.onlinePlan = null;
      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];
      fieldsToBeClear = [
        'dynamic_no_of_classes',
        'dynamic_class_ratio',
        'currency',
        'amount',
        'onlinePlanId',
      ];
      UpdateFieldsValues(fieldsToBeClear, null);

      fieldChoicesToBeClear = ['dynamic_no_of_classes', 'dynamic_class_ratio'];
      updateFieldChoices(fieldChoicesToBeClear, stateChanges.formFields, []);

      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();

      const finalFilteredPlanCourses = filteredPlanCourses.filter(
        mappedPlanCourse =>
          mappedPlanCourse.duration === value &&
          mappedPlanCourse.enrollment_type === form.enrollment_type &&
          mappedPlanCourse.course.type === form.course_type,
      );

      const arrayOfClassRatio = [];
      finalFilteredPlanCourses.map(ratio => arrayOfClassRatio.push(ratio.class_ratio));

      const choicesListForClassRatio = this.getFieldOptions(
        'dynamic_class_ratio',
        'onlinePlanOptions',
        arrayOfClassRatio,
      );
      updateFieldChoices(
        ['dynamic_class_ratio'],
        stateChanges.formFields,
        choicesListForClassRatio,
      );
    }
    if (key === 'dynamic_class_ratio') {
      stateChanges.shouldHideOptions = false;
      stateChanges.showDefalutPaymentLink = false;
      stateChanges.formFields = [...formFields, ...hiddenFormField];
      stateChanges.hiddenFormField = [];

      stateChanges.couponApplied = false;
      stateChanges.onlinePlan = null;

      fieldsToBeClear = ['dynamic_no_of_classes', 'currency', 'amount', 'onlinePlanId'];
      UpdateFieldsValues(fieldsToBeClear, null);

      fieldChoicesToBeClear = ['dynamic_no_of_classes'];
      updateFieldChoices(fieldChoicesToBeClear, stateChanges.formFields, []);

      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');
      ClearAddonCourse();

      const finalFilteredPlanCourses = filteredPlanCourses.filter(
        mappedPlanCourse =>
          mappedPlanCourse.duration === form.dynamic_duration &&
          mappedPlanCourse.enrollment_type === form.enrollment_type &&
          mappedPlanCourse.course.type === form.course_type &&
          mappedPlanCourse.class_ratio === value,
      );

      const arrayOfNoOfClasses = [];
      finalFilteredPlanCourses.map(classes =>
        arrayOfNoOfClasses.push(classes.no_of_classes),
      );

      const choicesListForClasses = this.getFieldOptions(
        'dynamic_no_of_classes',
        'onlinePlanOptions',
        arrayOfNoOfClasses,
      );
      updateFieldChoices(
        ['dynamic_no_of_classes'],
        stateChanges.formFields,
        choicesListForClasses,
      );
    }
    if (key === 'dynamic_no_of_classes') {
      stateChanges.couponApplied = false;
      stateChanges.onlinePlan = null;
      fieldsToBeClear = ['currency', 'amount', 'onlinePlanId'];
      UpdateFieldsValues(fieldsToBeClear, null);

      UpdateFieldsValues(['coupon_code', 'currency', 'amount'], ' ');

      const finalFilteredPlanCourses = filteredPlanCourses.filter(
        mappedPlanCourse =>
          mappedPlanCourse.duration === form.dynamic_duration &&
          mappedPlanCourse.enrollment_type === form.enrollment_type &&
          mappedPlanCourse.course.type === form.course_type &&
          mappedPlanCourse.class_ratio === form.dynamic_class_ratio &&
          mappedPlanCourse.no_of_classes === value,
      );

      newForm.onlinePlanId =
        finalFilteredPlanCourses.length > 0 && finalFilteredPlanCourses[0].online_plan_id;

      stateChanges.FinalPlanSelected = onlinePlanOptions.filter(
        ({ id }) => id === newForm.onlinePlanId,
      );

      stateChanges.onlinePlan =
        stateChanges.FinalPlanSelected.length > 0 && stateChanges.FinalPlanSelected[0];
      newForm.amount =
        stateChanges.FinalPlanSelected.length > 0 &&
        stateChanges.FinalPlanSelected[0].amount;
      newForm.currency =
        stateChanges.FinalPlanSelected.length > 0 &&
        stateChanges.FinalPlanSelected[0].currency;
      if (plans && plans.length) {
        const shouldShowRenewalPaymentLink = this.shouldShowRenewalPaymentLink(
          stateChanges.FinalPlanSelected,
          onlineBandOptions,
        );

        stateChanges.showDefalutPaymentLink = shouldShowRenewalPaymentLink;
        stateChanges.shouldHideOptions =
          !showNormalFlow && validityTillDate > 0 && shouldShowRenewalPaymentLink;
      }
      const fieldToHide = [
        'coupon_code',
        'currency',
        'amount',
        'teacher_id',
        'payment_client',
      ];

      if (stateChanges.shouldHideOptions) {
        hideFormFields(fieldToHide);
      }
      this.callDiscountApi(
        newForm['coupon_code'],
        newForm.onlinePlanId,
        isIndianPayment(newForm.currency),
      );
    }

    if (key === 'teacher_id' && value) {
      const { online_band: onlineBandId, enrollment_type: enrollmentType } = newForm;

      const isTeacherStudentBandMismatch = this.checkTeacherStudentBandMismatch(
        onlineBandId,
        value,
        enrollmentType,
      );
      if (isTeacherStudentBandMismatch) {
        newForm.teacher_id = '';
        errorMessage =
          "Selected plan's band does not match with teacher's online band. Please change teacher or online band.";
      }
    }

    stateChanges.errorText = errorMessage;
    stateChanges.message = null;
    stateChanges.form = newForm;
    stateChanges.addonForm = newAddonForm;
    this.setState({ ...stateChanges });

    if (
      !errorMessage &&
      newForm &&
      newForm.onlinePlanId &&
      key === 'teacher_id' &&
      value !== form[key] &&
      value &&
      !stateChanges.shouldHideOptions
    ) {
      this.callDiscountApi(
        newForm['coupon_code'],
        newForm.onlinePlanId,
        isIndianPayment(newForm.currency),
        value,
      );
    }

    const { enrollment_type: enrollmentTypeVal } = newForm;
    const canSelectTeacher = !!enrollmentTypeVal;
    newState.formFields.find(
      field => field.name === 'teacher_id',
    ).editable = canSelectTeacher;
  };

  getAddonPayload = () => {
    const { addonForm } = this.state;

    let addonPayload = [];

    for (let index = 0; index < addonForm.length; index++) {
      if (!addonForm[index].addon_course) {
        this.setState({
          errorText: 'Addon Course field can not be empty',
          message: null,
        });
        return -1;
      }
      if (!addonForm[index].addon_type) {
        this.setState({ errorText: 'Addon Type field can not be empty', message: null });
        return -1;
      }
      if (!addonForm[index].addon_name) {
        this.setState({ errorText: 'Addon Name field can not be empty', message: null });
        return -1;
      }

      let course_id = addonForm[index].addon_course.value.course_id;
      let addon_id = addonForm[index].addon_name.value.id;
      let comments = addonForm[index].comments;
      let addon_data = { course_id: course_id, id: addon_id, comments: comments };

      addonPayload.push(addon_data);
    }

    if (addonPayload.length === 0) return null;

    return addonPayload;
  };

  generatePaymentLink = () => {
    const { actions, student, isFirstTimePayment } = this.props;
    const {
      form,
      paymentLinkPost: { id },
      onlinePlan,
    } = this.state;
    const {
      dynamic_duration,
      dynamic_no_of_classes,
      teacher_id,
      enrollment_type: enrollmentType,
      online_band: onlineBandId,
    } = form;

    if (!onlinePlan) {
      this.setState({ errorText: 'Please select a plan', message: null });
      return;
    }
    const isTeacherStudentBandMismatch = this.checkTeacherStudentBandMismatch(
      onlineBandId,
      teacher_id,
      enrollmentType,
    );

    if (isTeacherStudentBandMismatch) {
      this.setState({
        errorText:
          "Selected plan's band does not match with teacher's online band. Please change teacher or online band.",
        message: null,
      });
      return;
    }

    if (!teacher_id) {
      this.setState({ errorText: 'Please select a teacher', message: null });
      return;
    }

    this.setState({ linkGenerated: true });
    const classesPerWeek = Math.floor(
      parseInt(dynamic_no_of_classes) / (parseInt(dynamic_duration) * 4),
    );

    const data = {};
    data['classes_per_week'] = classesPerWeek;
    data['online_plan_id'] = onlinePlan.id;
    data['payment_client'] = form['payment_client'];
    data['teacher_id'] = teacher_id;
    data['enrollment_type'] = enrollmentType;
    if (form['currency'] === 'INR') {
      data['show_installment_options'] = this.state.isEMIEnabled;
    }

    if (form['coupon_code']) {
      data['coupon_code'] = form['coupon_code'].trim();
    }

    data['addons'] = this.getAddonPayload();
    if (data['addons'] === -1) {
      return;
    }

    actions.createPaymentLink(id, data, { studentId: student.id });
  };

  onSubmit = event => {
    event.preventDefault();
  };

  renderFormHeader = () => {
    return (
      <HeaderHeadWrapper>
        <Text size="xlarge" align="center">
          Create Payment Link
        </Text>
      </HeaderHeadWrapper>
    );
  };

  renderFormField = field => {
    const { form, couponApplied } = this.state;
    const { coupon_code: couponCode } = form || {};

    const disabled = field.disabled || !field.editable;
    const required = field.required;
    const placeholder = disabled ? '' : field.label;
    let disabledField = false;
    if (field.name === 'coupon_code') {
      if (couponApplied && couponCode && couponCode.trim()) {
        disabledField = true;
      }
    }

    return renderFormFieldModule({
      ...field,
      value: form[field.name],
      onChange: this[getInputChangeMethod(field)],
      onInputChange: this.onTeacherSearch,
      required,
      disabled: disabled || disabledField,
      placeholder,
    });
  };

  renderFormFields = () => {
    const { formFields, form, bandId } = this.state;
    const {
      course_type,
      dynamic_class_ratio,
      dynamic_duration,
      dynamic_no_of_classes,
      grade_band,
      enrollment_type,
    } = form || {};

    let renderedFields = formFields.map(field => {
      return this.renderFormField(field);
    });
    if (
      bandId &&
      course_type &&
      grade_band &&
      dynamic_class_ratio &&
      dynamic_duration &&
      dynamic_no_of_classes &&
      enrollment_type
    ) {
      renderedFields.splice(8, 0, this.renderCourseDetailsview());
    }

    return <FieldWrapper>{renderedFields}</FieldWrapper>;
  };

  couponErrorMsg = (onlinePlan, isCouponCodeEmpty) => {
    if (!onlinePlan) {
      return 'Please select a plan';
    }
    if (isCouponCodeEmpty) {
      return 'Coupon code field is empty';
    }
    return null;
  };

  applyCouponButtonClicked = isCouponAdded => {
    const { form, onlinePlan } = this.state;
    const { currency, onlinePlanId, coupon_code: couponCode, couponSuccessfullyApplied } =
      form || {};
    const newform = { ...form };

    this.setState({
      errorText: null,
      message: null,
    });
    let couponApplied = false;
    const isCouponCodeEmpty = !couponCode || couponCode === ' ';
    let canCallDiscountApi = false;

    if (isCouponAdded) {
      //if applying coupon
      const couponErrorMsg = this.couponErrorMsg(onlinePlan, isCouponCodeEmpty);
      if (couponErrorMsg) {
        this.setState({
          errorText: couponErrorMsg,
          message: null,
        });
        return;
      }
      // after selecting online plan and applying coupon code.
      couponApplied = true;
      canCallDiscountApi = true;
    } else {
      newform.coupon_code = ' ';
      // if resetting coupon then coupon shouldn't be empty and successfully applied.
      canCallDiscountApi = !isCouponCodeEmpty && couponSuccessfullyApplied;
      this.setState({ form: newform });
    }

    if (canCallDiscountApi) {
      this.setState(
        {
          errorText: null,
          message: null,
          couponApplied,
        },
        () => this.callDiscountApi(couponCode, onlinePlanId, isIndianPayment(currency)),
      );
    }
  };

  renderButtons = () => {
    return (
      <ButtonWrapper justifyContent="center" width="100%">
        <LinkButton
          text="Add offline payment"
          label="Add offline payment"
          onClick={() => this.uploadPaymentData()}
        />
        <SpanWrapper>
          <Button
            label="Generate Payment Link"
            onClick={() => this.generatePaymentLink()}
          />
        </SpanWrapper>
      </ButtonWrapper>
    );
  };

  renderCourseDetailsview = () => {
    const {
      onlinePlan: { plan_courses: planCourses } = {},
      shouldHideOptions,
    } = this.state;

    const tableContent = [];

    if (planCourses) {
      planCourses.forEach(
        ({
          name,
          access_type,
          duration,
          class_ratio,
          grade,
          no_of_classes,
          online_plan_id,
          enrollment_type,
        }) => {
          const classesPerWeek = Math.floor(
            parseInt(no_of_classes) / (parseInt(duration) * 4),
          );

          tableContent.push({
            name: name,
            grade_band: grade,
            dynamic_duration: duration,
            dynamic_class_ratio: class_ratio,
            dynamic_classes_per_week: classesPerWeek,
            access_type: access_type,
            enrollment_type: enrollment_type,
          });
        },
      );

      if (shouldHideOptions) {
        return null;
      }

      return (
        <>
          <Separator transparent height="10" />
          <CourseInfo courseInfo={tableContent} />
          <Separator transparent height="10" />
        </>
      );
    }
  };

  uploadPaymentData = () => {
    const { actions, student } = this.props;
    actions.closeModal();
    actions.openModal(
      MODAL_FORM.PAYMENT_DATA_UPLOAD_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  handleAddonInputChange(key, i, value) {
    let addonForm = [...this.state.addonForm];
    addonForm[i] = { ...addonForm[i], [key]: value };
    this.setState({ addonForm: addonForm });
  }

  renderAddonsInputField(addon, index, field) {
    return (
      <Field key={field.name + index}>
        <Label profileView={field.profileView}>
          {field.label}
          {field.required ? <Asterisk>*</Asterisk> : null}
        </Label>
        <Input
          style={{ width: '210px' }}
          name={field.name}
          placeholder={field.placeholder}
          type={field.type}
          required={field.required}
          value={addon[field.name]}
          onChange={this.handleAddonInputChange.bind(this, field.name, index)}
          disabled={field.disabled}
          profileView={field.profileView || null}
          display={field.display || null}
          maxLength={field.maxlength || null}
        />
      </Field>
    );
  }

  handleAddonOptionChange(name, index, choice) {
    let stateChanges = {};
    let addonForm = [...this.state.addonForm];

    if (name === 'addon_type' && choice !== addonForm[index][name] && choice) {
      addonForm[index].addon_name = null;
      const { allAddonOptions } = this.state;

      let addon_type = choice.value;
      const addonNameChoicesList = getOptions({
        field: 'addon_name',
        addonNameOptions: allAddonOptions[addon_type],
      });

      addonForm[index].addonFormFields.find(
        field => field.name === 'addon_name',
      ).choices = addonNameChoicesList;
    }
    addonForm[index] = { ...addonForm[index], [name]: choice };

    stateChanges.addonForm = addonForm;
    this.setState({ ...stateChanges });
  }

  renderAddonSelectField(addon, index, field) {
    const choiceList = addon.addonFormFields.find(
      formField => formField.name === field.name,
    ).choices;
    return (
      <Field key={field.name + index}>
        <Label profileView={field.profileView}>
          {field.label}
          {field.required ? <Asterisk>*</Asterisk> : null}
        </Label>
        <SelectInput
          required={field.required}
          name={field.name}
          value={addon[field.name]}
          onChange={this.handleAddonOptionChange.bind(this, field.name, index)}
          isSearchable
          isDisabled={field.disabled}
          isMulti={!!field.multiple}
          options={choiceList}
        />
      </Field>
    );
  }

  renderAddonFormField(addon, index, field) {
    switch (field.fieldType) {
      case FIELD_TYPES.INPUT:
        return this.renderAddonsInputField(addon, index, field);
      case FIELD_TYPES.SELECT:
        return this.renderAddonSelectField(addon, index, field);
      default:
        return null;
    }
  }

  renderAddons() {
    const { addonForm } = this.state;
    return addonForm.map((addon, index) => (
      <CardWrapper>
        <FieldWrapper>
          {addonDataFields.map(field => {
            const disabled = field.disabled || !field.editable;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return this.renderAddonFormField(addon, index, {
              ...field,
              value: addonForm[index][field.name],
              required,
              disabled,
              placeholder,
            });
          })}
          <Button
            type="button"
            label="Remove Addon"
            onClick={this.removeAddonClick.bind(this, index)}
          />
        </FieldWrapper>
      </CardWrapper>
    ));
  }

  getAddonDefaults = () => {
    const AddonDefaults = {};
    addonDataFields.forEach(field => {
      AddonDefaults[field.name] = field.default;
    });
    AddonDefaults.addonFormFields = JSON.parse(JSON.stringify(this.getAddonFields()));
    return AddonDefaults;
  };

  addAddonClick() {
    let newAddon = this.getAddonDefaults();
    this.setState(prevState => ({
      addonForm: [...prevState.addonForm, newAddon],
    }));
  }

  removeAddonClick(i) {
    let addonForm = [...this.state.addonForm];
    addonForm.splice(i, 1);
    this.setState({ addonForm: addonForm });
  }

  showDiscount = () => {
    const { form } = this.state;
    const { discountsAndCreditsData, amount, currency } = form || {};
    const {
      discount_summary: { discounts } = {},
      credits: {
        available_credits: availableCredits,
        applied_credits: appliedCredits,
        net_amount: netAmount,
      } = {},
    } = discountsAndCreditsData || {};

    const showCredits = !!(
      currency === INR &&
      availableCredits &&
      availableCredits !== '0'
    );

    const amountText =
      currency && `${CURRENCY_SYMBOL_MAP[currency]}${Humanize.intComma(Number(amount))}`;

    const totalPayableAmount = (amountValue, separate) => {
      return (
        <>
          {separate ? ' - ' : ''}
          {CURRENCY_SYMBOL_MAP[form.currency]}
          {Humanize.intComma(amountValue)}
        </>
      );
    };

    const summaryWrapper = (label, value, smallText) => {
      return (
        <RowWrapper>
          <Col xs={6}>
            <Text>{label}</Text>
            {smallText && <Text size="small">{smallText}</Text>}
          </Col>
          <Col xs={6}>
            <Text align="right">{value}</Text>
          </Col>
        </RowWrapper>
      );
    };

    return (
      <>
        <PaymentText variant="large_semibold" align="center">
          Payment Summary
        </PaymentText>
        {summaryWrapper('Amount', amountText)}
        {discounts &&
          discounts.map(({ desc, amount }) => {
            return (
              <Fragment key={desc}>
                {summaryWrapper(desc, totalPayableAmount(amount, true))}
              </Fragment>
            );
          })}
        {showCredits && (
          <>
            <SeparatorWrapper height={2} />
            {summaryWrapper('Available Credits', availableCredits)}
            {!!parseInt(appliedCredits, 10) &&
              summaryWrapper('Applied Credits', parseInt(appliedCredits, 10))}
          </>
        )}
        <Separator height={2} />
        {summaryWrapper('Total Payable', totalPayableAmount(netAmount))}
      </>
    );
  };

  renderCouponBtn = () => {
    return (
      <DivWrapper marginTop="-64px">
        <ClearBtnWrapper onClick={() => this.applyCouponButtonClicked(false)}>
          <CloseIcon size={18} />
        </ClearBtnWrapper>
        <CouponBtnWrapper
          type="button"
          label="Apply Coupon"
          onClick={() => this.applyCouponButtonClicked(true)}
        />
      </DivWrapper>
    );
  };

  renderEmiOption = () => {
    return (
      <>
        <Separator transparent height="15" />
        <EmiWrapper>
          <label>{emiOptionsLabel}</label>
          <input
            type="checkbox"
            checked={this.state.isEMIEnabled}
            onChange={this.handleEmiToggle}
          />
        </EmiWrapper>
      </>
    );
  };

  render() {
    const {
      errorText,
      message,
      form: { onlinePlanId } = {},
      hyperLink,
      shouldHideOptions,
      renewalPlanData,
      showDefalutPaymentLink,
    } = this.state;

    const { can_create_renewal_payment: canCreateRenewalPayment } = renewalPlanData || {};
    const { student: { id: studentId } = {}, studentDetail } = this.props;

    const { primary_course: primaryCourse } = studentDetail || {};
    const { validity_till_date: validityTillDate } = primaryCourse || {};

    console.log(validityTillDate, canCreateRenewalPayment);

    const showDefaultRPlink =
      (canCreateRenewalPayment || !validityTillDate) &&
      onlinePlanId &&
      !shouldHideOptions &&
      showDefalutPaymentLink;
    const isCurrencyINR = this.state.form.currency === 'INR';

    return (
      <MainFieldWrapperr justifyContent="center" width="100%">
        {this.renderFormHeader()}
        <PaymentFieldWrapper>
          {!shouldHideOptions && this.renderTeachersList()}
          <Separator transparent height="25" />
          {this.renderFormFields()}
          {!shouldHideOptions && (
            <>
              {this.renderCouponBtn()}
              {isCurrencyINR && this.renderEmiOption()}
              <Separator transparent height="25" />
              {onlinePlanId && this.showDiscount()}
              {this.renderAddons()}
              <Separator transparent height="25" />
              <DivWrapper>
                <Button
                  type="button"
                  label="Add Addons"
                  onClick={this.addAddonClick.bind(this)}
                />
              </DivWrapper>
            </>
          )}
          {shouldHideOptions && (
            <Row alignItems="center">
              <CopyButtonText>
                <Text variant="body1regular">Renewal payment link</Text>
              </CopyButtonText>
              <CopyButtonWrapper>
                <CopyButton
                  style={{ width: '340px' }}
                  copyMessage="Renewal Payment Link"
                  text={`https://www.cuemath.com/student/leap-payment/${studentId}/?utm_source=la`}
                />
              </CopyButtonWrapper>
            </Row>
          )}
          <Separator transparent height="25" />
          {errorText && (
            <Message width="100%" error={true}>
              {errorText}
            </Message>
          )}
          {message && (
            <Message width="100%">
              {message}
              {hyperLink && (
                <CustomLink href={hyperLink} target="_blank" rel="noopener noreferrer">
                  &nbsp;- &nbsp;LINK
                </CustomLink>
              )}
            </Message>
          )}
          <Separator transparent height="25" />
          {!shouldHideOptions && <DivWrapper>{this.renderButtons()}</DivWrapper>}
          <Separator transparent height="25" />
          {showDefaultRPlink && (
            <>
              <Separator height={2} />
              <Row alignItems="center">
                <CopyButtonText>
                  <Text variant="body1regular">Renewal payment link</Text>
                </CopyButtonText>
                <CopyButtonWrapper>
                  <CopyButton
                    style={{ width: '340px' }}
                    copyMessage="Renewal Payment Link"
                    text={`https://www.cuemath.com/student/leap-payment/${studentId}/?utm_source=la`}
                  />
                </CopyButtonWrapper>
              </Row>
            </>
          )}
          <Separator transparent height="25" />
        </PaymentFieldWrapper>
      </MainFieldWrapperr>
    );
  }
}

export default connect(
  ({
    discountDetails,
    studentPaymentLink,
    applyCouponLink,
    onlinePlanList,
    onlineBand,
    planCourses,
    addonsList,
    teacherList,
    renewalPlans,
  }) => ({
    discountDetails,
    studentPaymentLink,
    applyCouponLink,
    onlinePlanList,
    onlineBand,
    planCourses,
    renewalPlans,
    addonsList,
    teacherList,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getDiscountDetails,
        getRenewalPlans,
        getAllOnlineBands,
        getOnlinePlans,
        getPlanCourses,
        getAllAddons,
        createPaymentLink,
        patchApplyCoupon,
        getTeacherList,
        closeModal,
        openModal,
      },
      dispatch,
    ),
  }),
)(NewPaymentModal);
